<template>
  <div>
    <data-table
      :title="title"
      :url="'/candidates' + (this.siteId ? '/site/' + this.siteId : '') + (this.clientId ? '/client/' + this.clientId : '')"
      :table-ref="tableRef"
      :fields="fields"
      :options="options"
      :show-search="false"
      sort-field="site_id,client_id,optionNo|desc"
      show-refresh
      :add-action="action"
      :add-props="addProps"
      :search-placeholder="searchPlaceholder"
      detail-component="acquire-detail-row"
      @totalChanged="totalOptions">

      <template #option="props">

            <!-- eslint-disable-next-line vue/no-v-html -- formatter output, numeric → <b><sup> ordinal markup -->
            <span v-html="addSuffix(props.rowData.optionNo)" />
            &nbsp;{{props.rowData.title ? props.rowData.title + (props.rowData.clientRef ? ' | Ref:' + props.rowData.clientRef : '') : props.rowData.clientRef}}</b>

            <span v-if="props.rowData.surveyDate">&nbsp;Survey Date: {{formatDate(props.rowData.surveyDate)}}</span>
            <span v-if="props.rowData.landType">&nbsp;|&nbsp;Land Type: <b>{{props.rowData.landType}}</b></span>
            <span v-if="props.rowData.classificationType">&nbsp;|&nbsp;Classification Type: <b>{{props.rowData.classificationType}}</b></span>

      </template>


      <template #details="props">
        <span label="Structure Type" v-if="props.rowData.structure"><i class="fa fa-broadcast-tower">&nbsp;</i>{{props.rowData.structure.name}}&nbsp;<b v-if="props.rowData.structureHeight">{{props.rowData.structureHeight}}m.</b>&nbsp;</span>
        <span v-if="props.rowData.antennaHeight">Ant. <i class="fa fa-arrows-alt-v"></i> <b>{{props.rowData.antennaHeight}}m</b></span>
      </template>


      <template #distance="props">

          <el-tooltip v-if="props.rowData.distanceFromNominal" content="Distance from Nominal"  placement="left">
             <span> <i class="fa fa-bullseye"></i> <b>{{props.rowData.distanceFromNominal}}m</b></span>
          </el-tooltip>

          <el-tooltip v-if="props.rowData.distanceAccessRoad" content="Distance to Access Road" placement="top">
             <span>&nbsp;|&nbsp;<i class="fa fa-road"></i> <b>{{props.rowData.distanceAccessRoad}}m</b></span>
          </el-tooltip>

          <el-tooltip v-if="props.rowData.distanceNearestBuilding" content="Distance to Nearest Building">
             <span>&nbsp;|&nbsp;<i class="fa fa-home"></i> <b>{{props.rowData.distanceNearestBuilding}}m</b></span>
          </el-tooltip>

          <el-tooltip v-if="props.rowData.distanceNearestPower" content="Distance to Nearest Commerical Power" placement="right">
            <span>&nbsp;|&nbsp;<i class="fa fa-plug"></i> <b>{{props.rowData.distanceNearestPower}}m</b></span>
          </el-tooltip>

      </template>


      <template #delete="props">
        <el-button v-if="isTelco() || isManager('project|property|finance|admin|management')" type="danger" circle icon="fa fa-trash" size="mini" @click="deleteOption(props.rowData)" />
      </template>

    </data-table>
    <center class="text-muted">Total: {{currentNo}}</center>

    </div>
</template>


<script>

import Vue from 'vue'

import SiteMixins from '@/mixins/SiteMixins'

import OptionAction from '@/components/actions/OptionAction'

import AcquireDetails from '@/components/requests/acquire/AcquireDetails'

Vue.component('acquire-detail-row', AcquireDetails)

export default {
    mixins: [SiteMixins],

    props: {

      siteData: {
        type: Object,
        required: true
      },

      siteId: {
        type: Number,
        default: null
      },

      sharerId: {
        type: Number,
        default: null
      },

      title: {
        type: String,
        default: 'Options'
      },

      noAdd: {
        type: Boolean,
        default: false
      },

      hideTop: {
        type: Boolean,
        default: true
      },

      showSearch: {
        type: Boolean,
        default: true
      },

      showRefresh: {
        type: Boolean,
        default: true
      },

      searchPlaceholder: {
        type: String,
        default: 'Client Ref, Land Type, Station Type...'

      },

      readOnly: {
        type: Boolean,
        default: false
      }


    },


    methods: {

      deleteOption (row) {
        this.deleteItem(this, row.id, '/candidate', this.addSuffix(row.optionNo) + 'Option [' + row.site.siteName + ']', null, true, this.tableRef)
      },

      totalOptions (no) {
        this.currentNo = no
        this.addProps.totalOptions = this.currentNo
      }

    },

    data () {

      return {
        tableRef: 'siteCandidatesTable',

        clientId: this.isTelco() ? Number(this.org().id) : this.sharerId,
        currentNo: this.siteData.count ? this.siteData.count : 0,

        options: {
          siteData: this.siteData
        },

        action: OptionAction,
        addProps: {
          siteData: this.siteData,
          totalOptions: this.currentNo,
          adding: true
        },

        fields: [
          {
            name: 'clientStatus',
            title: 'Client Status',
            callback: this.formatStatus
          },
          {
            name: '__slot:option',
            title: 'Option'
          },
          {
            name: '__slot:details',
            titleClass: 'hidden-md-and-down',
            dataClass: 'hidden-md-and-down'
          },
          {
            name: '__slot:distance',
            titleClass: 'hidden-sm-and-down',
            dataClass: 'hidden-sm-and-down'
          },
          {
            name: '__slot:delete',
            titleClass: 'hidden-md-and-down',
            dataClass: 'hidden-md-and-down'
          }
        ]

      }

  },  // data


  mounted () {

    if (!this.telcoId && this.isTelco()) {
      this.telcoId = Number(this.org().id)
    }

  }

}

</script>
